var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGridAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 101,
    viewBox: "0 0 158 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2079 101H97.0004L60.6704 0H36.3924L0.000366211 101H19.5936L29.4057 72H67.3958L77.2079 101ZM34.7057 56L48.0369 16.0578H48.7732L62.1129 56H34.7057ZM158 0V16H142V85H158V101H107V85H123V16H107V0H158Z",
    fill: "#0044FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGridAi);
export default __webpack_public_path__ + "static/media/logo-grid-ai.3a208e59fadf083da6e246c6f8974271.svg";
export { ForwardRef as ReactComponent };